<template>
    <footer class="footer hidden-xs-down">
        <p>© Primary Origin. All rights reserved.</p>

        <ul class="nav footer__nav">
            <a class="nav-link" href="/">Homepage</a>
        </ul>
    </footer>
</template>

<script>
export default {
  name: 'AppFooter',
};
</script>
